import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
const ApptOfficeNote = ({ byRoute, className }) => {
    var _a;
    const { t } = useTranslation();
    const { fullAppt } = byRoute;
    const description = (_a = fullAppt.appointment) === null || _a === void 0 ? void 0 : _a.description;
    if (!description) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ className: className }, { children: _jsxs("div", Object.assign({ className: "alert alert--warning text-pre-line" }, { children: [_jsx("div", Object.assign({ className: "alert-title" }, { children: t('label.office_note') })), description] })) })));
};
export default observer(ApptOfficeNote);
